import { render, staticRenderFns } from "./header.vue?vue&type=template&id=013f2400"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/usr/src/app/components/widgets/navbar.vue').default,HeaderWidgets: require('/usr/src/app/components/widgets/header-widgets.vue').default,Header: require('/usr/src/app/components/layout/header.vue').default})
